import React from "react";
import { getActivityFeed_activityFeed as ActivityFeed } from "types/gql-types";

interface Props {
  activity: ActivityFeed;
}

const LetterMessage: React.FC<Props> = ({ activity: { message } }) => {
  const [visible, setVisible] = React.useState(false);
  if (!message) return null;
  return (
    <div>
      <a
        href=""
        onClick={event => {
          event.preventDefault();
          setVisible(!visible);
        }}
      >
        Preview
      </a>
      {visible && <div dangerouslySetInnerHTML={{ __html: message.body || "" }}></div>}
    </div>
  );
};

export default LetterMessage;
